import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import './Login.css';

const BACK_API_BASE_URL = process.env.REACT_APP_BACK_API_BASE_URL;

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginCheck, setLoginCheck] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();

    try {
      const response = await fetch(
       `${BACK_API_BASE_URL}/api/user/login`, 
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email,
            password: password,
          }),
        }
      );
      // console.log(response)

      if (response.ok) {
        const result = await response.json();
        setLoginCheck(false);
        // console.log(result)
        sessionStorage.setItem("token", result.token);
        sessionStorage.setItem("role", result.role);

        // console.log(sessionStorage.getItem("token"))
        // console.log(sessionStorage.getItem("role"))

        // navigate("/building-list");
        if (result.role === "ADMIN") {
          navigate("/admin");
        } else {
          navigate("/building-list");
        }
      } else {
        setLoginCheck(true);
      }
    } catch (error) {
      console.error("로그인 중 오류 발생:", error);
      setLoginCheck(true);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(prevShowPassword => !prevShowPassword);
  };

  const handleLogoClick = () => {
    navigate("/building-list");
  };

  return (
    <div className="login-page">
      <div className="top">
        <img 
          src="/logo.png" 
          alt="Cleanier Building" 
          className="complete-logo"
          onClick={handleLogoClick} />
      </div>
      <div className="login-container">
        <form className="login-form" onSubmit={handleLogin}>
          <div className="email-field">
            <input 
              type="text"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="이메일주소를 입력해 주세요"
            />
          </div>

          <div className="password-field">
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호를 입력해 주세요"
            />
            <img 
            src={showPassword ? "/seePwd.png" : "/hidePwd.png"}
            alt={showPassword ? "Hide password" : "Show password"}
            onClick={togglePasswordVisibility}
            className="password-toggle-icon" />
          </div>

          {loginCheck && (
            <div className="login-error-message">
              입력한 아이디와 비밀번호가 유효하지 않습니다.<br/>
              확인 후 다시 시도해주세요.
            </div>
          )}

          <button type="submit" className="login-button">로그인</button>

          <div className="signup-link">
            <div className="question-label">
              아직 회원이 아니신가요?
            </div>
            <Link to="/signup" className="signup-button">회원가입</Link>
          </div>
        </form>
      </div>

      <div className="login-problem-field">
        비밀번호 분실 등 로그인 문제가 있는 경우 고객센터로 문의해주세요.
      </div>
      <div className="ksd-number-field">
        <img src="/call.png" alt="Call Service Center" className="login-problem-icon" />
        1833-7470
      </div>


      <footer className="footer">
        <img src="/ksdlogo.png" alt="ksd logo" className="footer-logo" />
        <div className="footer-text">
          Copyright Korea Space Data Inc. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default Login;
